export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";